import React, { Component } from "react";
import ReactGA from "react-ga";
import { Link } from "react-router-dom";
import BannerImg from "../../assets/images/banner/objectives.png";
import { Helmet } from "react-helmet";

class Objective extends Component {
  state = {};
  render() {
    ReactGA.initialize("UA-5235714-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>Enterprise Collaboration | Technology Ecosystem Experience | Avani Cimcon</title>
          <meta
            name="keywords"
            content="It Services and software solutions, Objective and Goal Setting, Customer Satisfaction Objectives, Company Objective, Goal and Objectives, Corporate partners"
          />
          <meta
            name="description"
            content="Enterprise Collaboration explains how Avani Cimcon works with technology ecosystems, system integrators and delivery partners to support joint enterprise delivery, interoperability and implementation experience."
          />
        </Helmet>

        <div className="page-banner d-flex align-items-center justify-content-center text-white">
          <div className="page-title container position-relative">
            <h1 className="font-weight-bold text-uppercase">Enterprise Collaboration</h1>
            <h5>Technology ecosystem experience and delivery partnerships</h5>
          </div>
          <img className="page-banner-img" src={BannerImg} alt="" />
          <div className="page-banner-overlay"></div>
        </div>

        <div className="inner-page mt-5 mb-5 ">
          <div className="container">
            <div className="text-justify">
              <h2 className="text-primary">Technology ecosystem experience</h2>
              <p>
                Partners are an important component of the Avani Cimcon Technologies business
                model. This page shows how the company works with technology providers, delivery
                teams and system integrators to solve enterprise problems together.
              </p>
              <p>
                The emphasis is on enterprise collaboration, interoperability and joint delivery,
                not recruitment. The story is the ability to combine software products, IT
                services and partner capabilities into a broader delivery ecosystem.
              </p>

              <div className="shadow-sm p-4 mt-4">
                <h5 className="text-primary mb-3">Enterprise collaboration</h5>
                <p className="mb-0">
                  Partners help extend implementation capacity, add integration depth and support
                  customer programs that require multiple capabilities working together.
                </p>
              </div>

              <div className="shadow-sm p-4 mt-4">
                <h5 className="text-primary mb-3">Delivery partnerships</h5>
                <ul>
                  <li className="mb-3">
                    To align IT services and software solutions with the broader ecosystem
                    capabilities offered by partners
                  </li>
                  <li className="mb-3">
                    To support partners in solution delivery, implementation and post-sales support
                  </li>
                  <li className="mb-3">
                    To jointly deliver solutions so both parties can serve the end customer well
                  </li>
                  <li>
                    To provide committed resource, technical and infrastructure support for
                    cost-effective delivery of enterprise solutions
                  </li>
                </ul>
              </div>

              <h5 className="text-primary mt-4 mb-3">
                Technology ecosystem experience includes:
              </h5>
              <div className="shadow-sm p-4">
                <ul>
                  <li className="mb-3">
                    Cost-effective solutions for enterprise delivery programs
                  </li>
                  <li className="mb-3">
                    Interoperability across systems, platforms and services
                  </li>
                  <li className="mb-3">Integrity and transparency across shared engagements</li>
                  <li className="mb-3">
                    Innovative solutions by blending technology, implementation and support
                  </li>
                  <li>Dedicated offshore software development capability in India</li>
                </ul>
              </div>

              <div className="shadow-sm p-4 mt-4">
                <h5 className="text-primary mb-3">How this helps enterprise clients</h5>
                <p className="mb-0">
                  Joint delivery models help customers adopt systems that fit into real
                  environments. Related pages:{" "}
                  <Link to="/it-consulting-services">IT Consulting Services</Link>,{" "}
                  <Link to="/international-projects">International Projects</Link>, and{" "}
                  <Link to="/domestic-projects">Domestic Projects</Link>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Objective;
